import { render, staticRenderFns } from "./configProducts.vue?vue&type=template&id=2836ddcc&scoped=true&"
import script from "./configProducts.vue?vue&type=script&lang=js&"
export * from "./configProducts.vue?vue&type=script&lang=js&"
import style0 from "./configProducts.vue?vue&type=style&index=0&id=2836ddcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836ddcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2836ddcc')) {
      api.createRecord('2836ddcc', component.options)
    } else {
      api.reload('2836ddcc', component.options)
    }
    module.hot.accept("./configProducts.vue?vue&type=template&id=2836ddcc&scoped=true&", function () {
      api.rerender('2836ddcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_reward_configuration/form/components/configProducts.vue"
export default component.exports